export const DEFAULT_WHEEL_TICK_SOUND_PRESET_ID = 'tick';

export const wheelTickSoundPresets = [
  {
    id: 'tick',
    labelKey: 'appearanceTickSoundPresetTick',
    src: `${process.env.REACT_APP_CDN_BASE_URL}/sounds/tick.mp3`,
    isBackground: false,
  },
  {
    id: 'lounge',
    labelKey: 'appearanceTickSoundPresetLounge',
    src: `${process.env.REACT_APP_CDN_BASE_URL}/sounds/lounge.mp3`,
    isBackground: true,
  },
  {
    id: 'kekw',
    labelKey: 'appearanceTickSoundPresetKekw',
    src: `${process.env.REACT_APP_CDN_BASE_URL}/sounds/kekw.mp3`,
    isBackground: true,
  },
  {
    id: 'beep',
    labelKey: 'appearanceTickSoundPresetBeep',
    src: `${process.env.REACT_APP_CDN_BASE_URL}/sounds/beep.mp3`,
    isBackground: false,
  },
];

const wheelTickSoundPresetMap = new Map(
  wheelTickSoundPresets.map((preset) => [preset.id, preset]),
);

export const getWheelTickSoundPreset = (presetId) => (
  wheelTickSoundPresetMap.get(presetId)
  || wheelTickSoundPresetMap.get(DEFAULT_WHEEL_TICK_SOUND_PRESET_ID)
);

export const isWheelTickSoundPreset = (presetId) => (
  wheelTickSoundPresetMap.has(presetId)
);

export const isWheelTickSoundBackground = (tickSound) => {
  if (tickSound?.source === 'custom') {
    return tickSound.isBackground === true;
  }

  if (tickSound?.source === 'preset') {
    return getWheelTickSoundPreset(tickSound.presetId).isBackground;
  }

  return false;
};

export const resolveWheelTickSound = (tickSound, customSoundUrl) => {
  if (tickSound?.source === 'none') {
    return null;
  }

  if (tickSound?.source === 'custom') {
    return customSoundUrl || null;
  }

  return getWheelTickSoundPreset(tickSound?.presetId).src;
};

export const createWheelSoundConfig = ({
  tickSound,
  customSoundUrl,
  volume,
  tickRateLimit = 55,
}) => {
  const soundUrl = resolveWheelTickSound(tickSound, customSoundUrl);
  const normalizedVolume = Number.isFinite(Number(volume)) ? Number(volume) : 0.2;
  const isBackground = isWheelTickSoundBackground(tickSound);

  return {
    enabled: Boolean(soundUrl) && normalizedVolume > 0,
    tick: isBackground ? undefined : soundUrl || undefined,
    spinLoop: isBackground ? soundUrl || undefined : undefined,
    volume: normalizedVolume,
    tickRateLimit,
  };
};
